import React from 'react';
import { Box, Typography } from '@mui/material';
import { getNestedValue } from './util';

const SmartContainer = ({
  model,
  title,
  children,
  sx = {},
  onChange,
  isEdit,
  titleSx = {},
  validatorResults,
  setValidatorResults,
  formState,
  contentSx = {}
}) => {
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      ...sx
    }}>

      {title && (
        <Typography
          variant="caption"
          component="div"
          sx={{
            color: 'text.secondary',
            fontSize: '0.75rem',
            lineHeight: 1.66,
            mb: 0
          }}
        >
          {title}
        </Typography>
      )}

      <Box sx={{
        width: '100%',
        ...contentSx
      }}>
        {React.Children.map(children, child => {
          if (React.isValidElement(child)) {
            const value = child.props.value? child.props.value: getNestedValue(model, child.props.field);
            return React.cloneElement(child, {
              model: model,
              value: value,
              onChange: onChange,
              isEdit: isEdit,
              field: child.props.field,
              formState: formState,
              validatorResults: validatorResults,
              setValidatorResults: setValidatorResults
            });
          }
          return child;
        })}
      </Box>
    </Box>
  );
};

export default SmartContainer;